import state from './state';
import getters from './getters';
import mutations from './mutations';
import VuexPersistence from 'vuex-persist'

import actions from './actions';

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default {
  modules: {
  },
  getters,
  state,
  mutations,
  actions,
  plugins: [vuexLocal.plugin]
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/components/store/index.js